export type OSIKeyword =
  | 'osi-approved'
  | 'discouraged'
  | 'non-reusable'
  | 'redundant'
  | 'popular'
  | 'obsolete'
  | 'copyleft'
  | 'special-purpose'
  | 'permissive'
  | 'miscellaneous'
  | 'retired';

export type License = {
  // From SPDX list
  id: string;
  name: string;
  isOsiApproved?: true;
  isDeprecatedLicenseId?: true;

  // From OSI list
  keywords?: OSIKeyword[];
};

//  --- AUTOGENERATED FROM HERE DOWN ---
// See ../scripts/fetch_licenses.js

// eslint-disable-next-line prettier/prettier
export const LICENSES: Record<string, License> = {
  '0bsd': { id: '0BSD', name: 'BSD Zero Clause License', isOsiApproved: true },
  aal: {
    id: 'AAL',
    name: 'Attribution Assurance License',
    isOsiApproved: true,
    keywords: ['osi-approved', 'discouraged', 'redundant'],
  },
  abstyles: { id: 'Abstyles', name: 'Abstyles License' },
  'adacore-doc': { id: 'AdaCore-doc', name: 'AdaCore Doc License' },
  'adobe-2006': {
    id: 'Adobe-2006',
    name: 'Adobe Systems Incorporated Source Code License Agreement',
  },
  'adobe-display-postscript': {
    id: 'Adobe-Display-PostScript',
    name: 'Adobe Display PostScript License',
  },
  'adobe-glyph': { id: 'Adobe-Glyph', name: 'Adobe Glyph List License' },
  'adobe-utopia': { id: 'Adobe-Utopia', name: 'Adobe Utopia Font License' },
  adsl: { id: 'ADSL', name: 'Amazon Digital Services License' },
  'afl-1.1': {
    id: 'AFL-1.1',
    name: 'Academic Free License v1.1',
    isOsiApproved: true,
  },
  'afl-1.2': {
    id: 'AFL-1.2',
    name: 'Academic Free License v1.2',
    isOsiApproved: true,
  },
  'afl-2.0': {
    id: 'AFL-2.0',
    name: 'Academic Free License v2.0',
    isOsiApproved: true,
  },
  'afl-2.1': {
    id: 'AFL-2.1',
    name: 'Academic Free License v2.1',
    isOsiApproved: true,
  },
  'afl-3.0': {
    id: 'AFL-3.0',
    name: 'Academic Free License v3.0',
    isOsiApproved: true,
    keywords: ['osi-approved', 'discouraged', 'redundant'],
  },
  afmparse: { id: 'Afmparse', name: 'Afmparse License' },
  'agpl-1.0': {
    id: 'AGPL-1.0',
    name: 'Affero General Public License v1.0',
    isDeprecatedLicenseId: true,
  },
  'agpl-1.0-only': {
    id: 'AGPL-1.0-only',
    name: 'Affero General Public License v1.0 only',
  },
  'agpl-1.0-or-later': {
    id: 'AGPL-1.0-or-later',
    name: 'Affero General Public License v1.0 or later',
  },
  'agpl-3.0': {
    id: 'AGPL-3.0',
    name: 'GNU Affero General Public License v3.0',
    isOsiApproved: true,
    isDeprecatedLicenseId: true,
    keywords: ['osi-approved'],
  },
  'agpl-3.0-only': {
    id: 'AGPL-3.0-only',
    name: 'GNU Affero General Public License v3.0 only',
    isOsiApproved: true,
  },
  'agpl-3.0-or-later': {
    id: 'AGPL-3.0-or-later',
    name: 'GNU Affero General Public License v3.0 or later',
    isOsiApproved: true,
  },
  aladdin: { id: 'Aladdin', name: 'Aladdin Free Public License' },
  amdplpa: { id: 'AMDPLPA', name: "AMD's plpa_map.c License" },
  aml: { id: 'AML', name: 'Apple MIT License' },
  'aml-glslang': { id: 'AML-glslang', name: 'AML glslang variant License' },
  ampas: {
    id: 'AMPAS',
    name: 'Academy of Motion Picture Arts and Sciences BSD',
  },
  'antlr-pd': { id: 'ANTLR-PD', name: 'ANTLR Software Rights Notice' },
  'antlr-pd-fallback': {
    id: 'ANTLR-PD-fallback',
    name: 'ANTLR Software Rights Notice with license fallback',
  },
  'apache-1.0': { id: 'Apache-1.0', name: 'Apache License 1.0' },
  'apache-1.1': {
    id: 'Apache-1.1',
    name: 'Apache License 1.1',
    isOsiApproved: true,
    keywords: ['discouraged', 'obsolete', 'osi-approved'],
  },
  'apache-2.0': {
    id: 'Apache-2.0',
    name: 'Apache License 2.0',
    isOsiApproved: true,
    keywords: ['osi-approved', 'popular', 'permissive'],
  },
  apafml: { id: 'APAFML', name: 'Adobe Postscript AFM License' },
  'apl-1.0': {
    id: 'APL-1.0',
    name: 'Adaptive Public License 1.0',
    isOsiApproved: true,
    keywords: ['osi-approved', 'miscellaneous'],
  },
  'app-s2p': { id: 'App-s2p', name: 'App::s2p License' },
  'apsl-1.0': {
    id: 'APSL-1.0',
    name: 'Apple Public Source License 1.0',
    isOsiApproved: true,
  },
  'apsl-1.1': {
    id: 'APSL-1.1',
    name: 'Apple Public Source License 1.1',
    isOsiApproved: true,
  },
  'apsl-1.2': {
    id: 'APSL-1.2',
    name: 'Apple Public Source License 1.2',
    isOsiApproved: true,
  },
  'apsl-2.0': {
    id: 'APSL-2.0',
    name: 'Apple Public Source License 2.0',
    isOsiApproved: true,
    keywords: ['discouraged', 'non-reusable', 'osi-approved'],
  },
  'arphic-1999': { id: 'Arphic-1999', name: 'Arphic Public License' },
  'artistic-1.0': {
    id: 'Artistic-1.0',
    name: 'Artistic License 1.0',
    isOsiApproved: true,
    keywords: ['osi-approved', 'discouraged', 'obsolete'],
  },
  'artistic-1.0-cl8': {
    id: 'Artistic-1.0-cl8',
    name: 'Artistic License 1.0 w/clause 8',
    isOsiApproved: true,
  },
  'artistic-1.0-perl': {
    id: 'Artistic-1.0-Perl',
    name: 'Artistic License 1.0 (Perl)',
    isOsiApproved: true,
  },
  'artistic-2.0': {
    id: 'Artistic-2.0',
    name: 'Artistic License 2.0',
    isOsiApproved: true,
    keywords: ['miscellaneous', 'osi-approved'],
  },
  'aswf-digital-assets-1.0': {
    id: 'ASWF-Digital-Assets-1.0',
    name: 'ASWF Digital Assets License version 1.0',
  },
  'aswf-digital-assets-1.1': {
    id: 'ASWF-Digital-Assets-1.1',
    name: 'ASWF Digital Assets License 1.1',
  },
  baekmuk: { id: 'Baekmuk', name: 'Baekmuk License' },
  bahyph: { id: 'Bahyph', name: 'Bahyph License' },
  barr: { id: 'Barr', name: 'Barr License' },
  beerware: { id: 'Beerware', name: 'Beerware License' },
  'bitstream-charter': {
    id: 'Bitstream-Charter',
    name: 'Bitstream Charter Font License',
  },
  'bitstream-vera': {
    id: 'Bitstream-Vera',
    name: 'Bitstream Vera Font License',
  },
  'bittorrent-1.0': {
    id: 'BitTorrent-1.0',
    name: 'BitTorrent Open Source License v1.0',
  },
  'bittorrent-1.1': {
    id: 'BitTorrent-1.1',
    name: 'BitTorrent Open Source License v1.1',
  },
  blessing: { id: 'blessing', name: 'SQLite Blessing' },
  'blueoak-1.0.0': {
    id: 'BlueOak-1.0.0',
    name: 'Blue Oak Model License 1.0.0',
  },
  'boehm-gc': { id: 'Boehm-GC', name: 'Boehm-Demers-Weiser GC License' },
  borceux: { id: 'Borceux', name: 'Borceux license' },
  'brian-gladman-3-clause': {
    id: 'Brian-Gladman-3-Clause',
    name: 'Brian Gladman 3-Clause License',
  },
  'bsd-1-clause': {
    id: 'BSD-1-Clause',
    name: 'BSD 1-Clause License',
    isOsiApproved: true,
  },
  'bsd-2-clause': {
    id: 'BSD-2-Clause',
    name: 'BSD 2-Clause "Simplified" License',
    isOsiApproved: true,
    keywords: ['osi-approved', 'popular', 'permissive'],
  },
  'bsd-2-clause-freebsd': {
    id: 'BSD-2-Clause-FreeBSD',
    name: 'BSD 2-Clause FreeBSD License',
    isDeprecatedLicenseId: true,
  },
  'bsd-2-clause-netbsd': {
    id: 'BSD-2-Clause-NetBSD',
    name: 'BSD 2-Clause NetBSD License',
    isDeprecatedLicenseId: true,
  },
  'bsd-2-clause-patent': {
    id: 'BSD-2-Clause-Patent',
    name: 'BSD-2-Clause Plus Patent License',
    isOsiApproved: true,
  },
  'bsd-2-clause-views': {
    id: 'BSD-2-Clause-Views',
    name: 'BSD 2-Clause with views sentence',
  },
  'bsd-3-clause': {
    id: 'BSD-3-Clause',
    name: 'BSD 3-Clause "New" or "Revised" License',
    isOsiApproved: true,
    keywords: ['osi-approved', 'popular', 'permissive'],
  },
  'bsd-3-clause-attribution': {
    id: 'BSD-3-Clause-Attribution',
    name: 'BSD with attribution',
  },
  'bsd-3-clause-clear': {
    id: 'BSD-3-Clause-Clear',
    name: 'BSD 3-Clause Clear License',
  },
  'bsd-3-clause-flex': {
    id: 'BSD-3-Clause-flex',
    name: 'BSD 3-Clause Flex variant',
  },
  'bsd-3-clause-hp': {
    id: 'BSD-3-Clause-HP',
    name: 'Hewlett-Packard BSD variant license',
  },
  'bsd-3-clause-lbnl': {
    id: 'BSD-3-Clause-LBNL',
    name: 'Lawrence Berkeley National Labs BSD variant license',
    isOsiApproved: true,
  },
  'bsd-3-clause-modification': {
    id: 'BSD-3-Clause-Modification',
    name: 'BSD 3-Clause Modification',
  },
  'bsd-3-clause-no-military-license': {
    id: 'BSD-3-Clause-No-Military-License',
    name: 'BSD 3-Clause No Military License',
  },
  'bsd-3-clause-no-nuclear-license': {
    id: 'BSD-3-Clause-No-Nuclear-License',
    name: 'BSD 3-Clause No Nuclear License',
  },
  'bsd-3-clause-no-nuclear-license-2014': {
    id: 'BSD-3-Clause-No-Nuclear-License-2014',
    name: 'BSD 3-Clause No Nuclear License 2014',
  },
  'bsd-3-clause-no-nuclear-warranty': {
    id: 'BSD-3-Clause-No-Nuclear-Warranty',
    name: 'BSD 3-Clause No Nuclear Warranty',
  },
  'bsd-3-clause-open-mpi': {
    id: 'BSD-3-Clause-Open-MPI',
    name: 'BSD 3-Clause Open MPI variant',
  },
  'bsd-3-clause-sun': {
    id: 'BSD-3-Clause-Sun',
    name: 'BSD 3-Clause Sun Microsystems',
  },
  'bsd-4-clause': {
    id: 'BSD-4-Clause',
    name: 'BSD 4-Clause "Original" or "Old" License',
  },
  'bsd-4-clause-shortened': {
    id: 'BSD-4-Clause-Shortened',
    name: 'BSD 4 Clause Shortened',
  },
  'bsd-4-clause-uc': {
    id: 'BSD-4-Clause-UC',
    name: 'BSD-4-Clause (University of California-Specific)',
  },
  'bsd-4.3reno': { id: 'BSD-4.3RENO', name: 'BSD 4.3 RENO License' },
  'bsd-4.3tahoe': { id: 'BSD-4.3TAHOE', name: 'BSD 4.3 TAHOE License' },
  'bsd-advertising-acknowledgement': {
    id: 'BSD-Advertising-Acknowledgement',
    name: 'BSD Advertising Acknowledgement License',
  },
  'bsd-attribution-hpnd-disclaimer': {
    id: 'BSD-Attribution-HPND-disclaimer',
    name: 'BSD with Attribution and HPND disclaimer',
  },
  'bsd-inferno-nettverk': {
    id: 'BSD-Inferno-Nettverk',
    name: 'BSD-Inferno-Nettverk',
  },
  'bsd-protection': { id: 'BSD-Protection', name: 'BSD Protection License' },
  'bsd-source-code': {
    id: 'BSD-Source-Code',
    name: 'BSD Source Code Attribution',
  },
  'bsd-systemics': {
    id: 'BSD-Systemics',
    name: 'Systemics BSD variant license',
  },
  'bsl-1.0': {
    id: 'BSL-1.0',
    name: 'Boost Software License 1.0',
    isOsiApproved: true,
    keywords: ['osi-approved'],
  },
  'busl-1.1': { id: 'BUSL-1.1', name: 'Business Source License 1.1' },
  'bzip2-1.0.5': {
    id: 'bzip2-1.0.5',
    name: 'bzip2 and libbzip2 License v1.0.5',
    isDeprecatedLicenseId: true,
  },
  'bzip2-1.0.6': {
    id: 'bzip2-1.0.6',
    name: 'bzip2 and libbzip2 License v1.0.6',
  },
  'c-uda-1.0': {
    id: 'C-UDA-1.0',
    name: 'Computational Use of Data Agreement v1.0',
  },
  'cal-1.0': {
    id: 'CAL-1.0',
    name: 'Cryptographic Autonomy License 1.0',
    isOsiApproved: true,
  },
  'cal-1.0-combined-work-exception': {
    id: 'CAL-1.0-Combined-Work-Exception',
    name: 'Cryptographic Autonomy License 1.0 (Combined Work Exception)',
    isOsiApproved: true,
  },
  caldera: { id: 'Caldera', name: 'Caldera License' },
  'catosl-1.1': {
    id: 'CATOSL-1.1',
    name: 'Computer Associates Trusted Open Source License 1.1',
    isOsiApproved: true,
    keywords: ['discouraged', 'non-reusable', 'osi-approved'],
  },
  'cc-by-1.0': {
    id: 'CC-BY-1.0',
    name: 'Creative Commons Attribution 1.0 Generic',
  },
  'cc-by-2.0': {
    id: 'CC-BY-2.0',
    name: 'Creative Commons Attribution 2.0 Generic',
  },
  'cc-by-2.5': {
    id: 'CC-BY-2.5',
    name: 'Creative Commons Attribution 2.5 Generic',
  },
  'cc-by-2.5-au': {
    id: 'CC-BY-2.5-AU',
    name: 'Creative Commons Attribution 2.5 Australia',
  },
  'cc-by-3.0': {
    id: 'CC-BY-3.0',
    name: 'Creative Commons Attribution 3.0 Unported',
  },
  'cc-by-3.0-at': {
    id: 'CC-BY-3.0-AT',
    name: 'Creative Commons Attribution 3.0 Austria',
  },
  'cc-by-3.0-de': {
    id: 'CC-BY-3.0-DE',
    name: 'Creative Commons Attribution 3.0 Germany',
  },
  'cc-by-3.0-igo': {
    id: 'CC-BY-3.0-IGO',
    name: 'Creative Commons Attribution 3.0 IGO',
  },
  'cc-by-3.0-nl': {
    id: 'CC-BY-3.0-NL',
    name: 'Creative Commons Attribution 3.0 Netherlands',
  },
  'cc-by-3.0-us': {
    id: 'CC-BY-3.0-US',
    name: 'Creative Commons Attribution 3.0 United States',
  },
  'cc-by-4.0': {
    id: 'CC-BY-4.0',
    name: 'Creative Commons Attribution 4.0 International',
  },
  'cc-by-nc-1.0': {
    id: 'CC-BY-NC-1.0',
    name: 'Creative Commons Attribution Non Commercial 1.0 Generic',
  },
  'cc-by-nc-2.0': {
    id: 'CC-BY-NC-2.0',
    name: 'Creative Commons Attribution Non Commercial 2.0 Generic',
  },
  'cc-by-nc-2.5': {
    id: 'CC-BY-NC-2.5',
    name: 'Creative Commons Attribution Non Commercial 2.5 Generic',
  },
  'cc-by-nc-3.0': {
    id: 'CC-BY-NC-3.0',
    name: 'Creative Commons Attribution Non Commercial 3.0 Unported',
  },
  'cc-by-nc-3.0-de': {
    id: 'CC-BY-NC-3.0-DE',
    name: 'Creative Commons Attribution Non Commercial 3.0 Germany',
  },
  'cc-by-nc-4.0': {
    id: 'CC-BY-NC-4.0',
    name: 'Creative Commons Attribution Non Commercial 4.0 International',
  },
  'cc-by-nc-nd-1.0': {
    id: 'CC-BY-NC-ND-1.0',
    name: 'Creative Commons Attribution Non Commercial No Derivatives 1.0 Generic',
  },
  'cc-by-nc-nd-2.0': {
    id: 'CC-BY-NC-ND-2.0',
    name: 'Creative Commons Attribution Non Commercial No Derivatives 2.0 Generic',
  },
  'cc-by-nc-nd-2.5': {
    id: 'CC-BY-NC-ND-2.5',
    name: 'Creative Commons Attribution Non Commercial No Derivatives 2.5 Generic',
  },
  'cc-by-nc-nd-3.0': {
    id: 'CC-BY-NC-ND-3.0',
    name: 'Creative Commons Attribution Non Commercial No Derivatives 3.0 Unported',
  },
  'cc-by-nc-nd-3.0-de': {
    id: 'CC-BY-NC-ND-3.0-DE',
    name: 'Creative Commons Attribution Non Commercial No Derivatives 3.0 Germany',
  },
  'cc-by-nc-nd-3.0-igo': {
    id: 'CC-BY-NC-ND-3.0-IGO',
    name: 'Creative Commons Attribution Non Commercial No Derivatives 3.0 IGO',
  },
  'cc-by-nc-nd-4.0': {
    id: 'CC-BY-NC-ND-4.0',
    name: 'Creative Commons Attribution Non Commercial No Derivatives 4.0 International',
  },
  'cc-by-nc-sa-1.0': {
    id: 'CC-BY-NC-SA-1.0',
    name: 'Creative Commons Attribution Non Commercial Share Alike 1.0 Generic',
  },
  'cc-by-nc-sa-2.0': {
    id: 'CC-BY-NC-SA-2.0',
    name: 'Creative Commons Attribution Non Commercial Share Alike 2.0 Generic',
  },
  'cc-by-nc-sa-2.0-de': {
    id: 'CC-BY-NC-SA-2.0-DE',
    name: 'Creative Commons Attribution Non Commercial Share Alike 2.0 Germany',
  },
  'cc-by-nc-sa-2.0-fr': {
    id: 'CC-BY-NC-SA-2.0-FR',
    name: 'Creative Commons Attribution-NonCommercial-ShareAlike 2.0 France',
  },
  'cc-by-nc-sa-2.0-uk': {
    id: 'CC-BY-NC-SA-2.0-UK',
    name: 'Creative Commons Attribution Non Commercial Share Alike 2.0 England and Wales',
  },
  'cc-by-nc-sa-2.5': {
    id: 'CC-BY-NC-SA-2.5',
    name: 'Creative Commons Attribution Non Commercial Share Alike 2.5 Generic',
  },
  'cc-by-nc-sa-3.0': {
    id: 'CC-BY-NC-SA-3.0',
    name: 'Creative Commons Attribution Non Commercial Share Alike 3.0 Unported',
  },
  'cc-by-nc-sa-3.0-de': {
    id: 'CC-BY-NC-SA-3.0-DE',
    name: 'Creative Commons Attribution Non Commercial Share Alike 3.0 Germany',
  },
  'cc-by-nc-sa-3.0-igo': {
    id: 'CC-BY-NC-SA-3.0-IGO',
    name: 'Creative Commons Attribution Non Commercial Share Alike 3.0 IGO',
  },
  'cc-by-nc-sa-4.0': {
    id: 'CC-BY-NC-SA-4.0',
    name: 'Creative Commons Attribution Non Commercial Share Alike 4.0 International',
  },
  'cc-by-nd-1.0': {
    id: 'CC-BY-ND-1.0',
    name: 'Creative Commons Attribution No Derivatives 1.0 Generic',
  },
  'cc-by-nd-2.0': {
    id: 'CC-BY-ND-2.0',
    name: 'Creative Commons Attribution No Derivatives 2.0 Generic',
  },
  'cc-by-nd-2.5': {
    id: 'CC-BY-ND-2.5',
    name: 'Creative Commons Attribution No Derivatives 2.5 Generic',
  },
  'cc-by-nd-3.0': {
    id: 'CC-BY-ND-3.0',
    name: 'Creative Commons Attribution No Derivatives 3.0 Unported',
  },
  'cc-by-nd-3.0-de': {
    id: 'CC-BY-ND-3.0-DE',
    name: 'Creative Commons Attribution No Derivatives 3.0 Germany',
  },
  'cc-by-nd-4.0': {
    id: 'CC-BY-ND-4.0',
    name: 'Creative Commons Attribution No Derivatives 4.0 International',
  },
  'cc-by-sa-1.0': {
    id: 'CC-BY-SA-1.0',
    name: 'Creative Commons Attribution Share Alike 1.0 Generic',
  },
  'cc-by-sa-2.0': {
    id: 'CC-BY-SA-2.0',
    name: 'Creative Commons Attribution Share Alike 2.0 Generic',
  },
  'cc-by-sa-2.0-uk': {
    id: 'CC-BY-SA-2.0-UK',
    name: 'Creative Commons Attribution Share Alike 2.0 England and Wales',
  },
  'cc-by-sa-2.1-jp': {
    id: 'CC-BY-SA-2.1-JP',
    name: 'Creative Commons Attribution Share Alike 2.1 Japan',
  },
  'cc-by-sa-2.5': {
    id: 'CC-BY-SA-2.5',
    name: 'Creative Commons Attribution Share Alike 2.5 Generic',
  },
  'cc-by-sa-3.0': {
    id: 'CC-BY-SA-3.0',
    name: 'Creative Commons Attribution Share Alike 3.0 Unported',
  },
  'cc-by-sa-3.0-at': {
    id: 'CC-BY-SA-3.0-AT',
    name: 'Creative Commons Attribution Share Alike 3.0 Austria',
  },
  'cc-by-sa-3.0-de': {
    id: 'CC-BY-SA-3.0-DE',
    name: 'Creative Commons Attribution Share Alike 3.0 Germany',
  },
  'cc-by-sa-3.0-igo': {
    id: 'CC-BY-SA-3.0-IGO',
    name: 'Creative Commons Attribution-ShareAlike 3.0 IGO',
  },
  'cc-by-sa-4.0': {
    id: 'CC-BY-SA-4.0',
    name: 'Creative Commons Attribution Share Alike 4.0 International',
  },
  'cc-pddc': {
    id: 'CC-PDDC',
    name: 'Creative Commons Public Domain Dedication and Certification',
  },
  'cc0-1.0': { id: 'CC0-1.0', name: 'Creative Commons Zero v1.0 Universal' },
  'cddl-1.0': {
    id: 'CDDL-1.0',
    name: 'Common Development and Distribution License 1.0',
    isOsiApproved: true,
    keywords: ['osi-approved', 'popular'],
  },
  'cddl-1.1': {
    id: 'CDDL-1.1',
    name: 'Common Development and Distribution License 1.1',
  },
  'cdl-1.0': { id: 'CDL-1.0', name: 'Common Documentation License 1.0' },
  'cdla-permissive-1.0': {
    id: 'CDLA-Permissive-1.0',
    name: 'Community Data License Agreement Permissive 1.0',
  },
  'cdla-permissive-2.0': {
    id: 'CDLA-Permissive-2.0',
    name: 'Community Data License Agreement Permissive 2.0',
  },
  'cdla-sharing-1.0': {
    id: 'CDLA-Sharing-1.0',
    name: 'Community Data License Agreement Sharing 1.0',
  },
  'cecill-1.0': {
    id: 'CECILL-1.0',
    name: 'CeCILL Free Software License Agreement v1.0',
  },
  'cecill-1.1': {
    id: 'CECILL-1.1',
    name: 'CeCILL Free Software License Agreement v1.1',
  },
  'cecill-2.0': {
    id: 'CECILL-2.0',
    name: 'CeCILL Free Software License Agreement v2.0',
  },
  'cecill-2.1': {
    id: 'CECILL-2.1',
    name: 'CeCILL Free Software License Agreement v2.1',
    isOsiApproved: true,
  },
  'cecill-b': {
    id: 'CECILL-B',
    name: 'CeCILL-B Free Software License Agreement',
  },
  'cecill-c': {
    id: 'CECILL-C',
    name: 'CeCILL-C Free Software License Agreement',
  },
  'cern-ohl-1.1': {
    id: 'CERN-OHL-1.1',
    name: 'CERN Open Hardware Licence v1.1',
  },
  'cern-ohl-1.2': {
    id: 'CERN-OHL-1.2',
    name: 'CERN Open Hardware Licence v1.2',
  },
  'cern-ohl-p-2.0': {
    id: 'CERN-OHL-P-2.0',
    name: 'CERN Open Hardware Licence Version 2 - Permissive',
    isOsiApproved: true,
  },
  'cern-ohl-s-2.0': {
    id: 'CERN-OHL-S-2.0',
    name: 'CERN Open Hardware Licence Version 2 - Strongly Reciprocal',
    isOsiApproved: true,
  },
  'cern-ohl-w-2.0': {
    id: 'CERN-OHL-W-2.0',
    name: 'CERN Open Hardware Licence Version 2 - Weakly Reciprocal',
    isOsiApproved: true,
  },
  cfitsio: { id: 'CFITSIO', name: 'CFITSIO License' },
  'check-cvs': { id: 'check-cvs', name: 'check-cvs License' },
  checkmk: { id: 'checkmk', name: 'Checkmk License' },
  clartistic: { id: 'ClArtistic', name: 'Clarified Artistic License' },
  clips: { id: 'Clips', name: 'Clips License' },
  'cmu-mach': { id: 'CMU-Mach', name: 'CMU Mach License' },
  'cnri-jython': { id: 'CNRI-Jython', name: 'CNRI Jython License' },
  'cnri-python': {
    id: 'CNRI-Python',
    name: 'CNRI Python License',
    isOsiApproved: true,
    keywords: ['discouraged', 'non-reusable', 'osi-approved'],
  },
  'cnri-python-gpl-compatible': {
    id: 'CNRI-Python-GPL-Compatible',
    name: 'CNRI Python Open Source GPL Compatible License Agreement',
  },
  'coil-1.0': { id: 'COIL-1.0', name: 'Copyfree Open Innovation License' },
  'community-spec-1.0': {
    id: 'Community-Spec-1.0',
    name: 'Community Specification License 1.0',
  },
  'condor-1.1': { id: 'Condor-1.1', name: 'Condor Public License v1.1' },
  'copyleft-next-0.3.0': {
    id: 'copyleft-next-0.3.0',
    name: 'copyleft-next 0.3.0',
  },
  'copyleft-next-0.3.1': {
    id: 'copyleft-next-0.3.1',
    name: 'copyleft-next 0.3.1',
  },
  'cornell-lossless-jpeg': {
    id: 'Cornell-Lossless-JPEG',
    name: 'Cornell Lossless JPEG License',
  },
  'cpal-1.0': {
    id: 'CPAL-1.0',
    name: 'Common Public Attribution License 1.0',
    isOsiApproved: true,
    keywords: ['osi-approved'],
  },
  'cpl-1.0': {
    id: 'CPL-1.0',
    name: 'Common Public License 1.0',
    isOsiApproved: true,
    keywords: ['discouraged', 'obsolete', 'osi-approved'],
  },
  'cpol-1.02': { id: 'CPOL-1.02', name: 'Code Project Open License 1.02' },
  cronyx: { id: 'Cronyx', name: 'Cronyx License' },
  crossword: { id: 'Crossword', name: 'Crossword License' },
  crystalstacker: { id: 'CrystalStacker', name: 'CrystalStacker License' },
  'cua-opl-1.0': {
    id: 'CUA-OPL-1.0',
    name: 'CUA Office Public License v1.0',
    isOsiApproved: true,
    keywords: ['discouraged', 'non-reusable', 'osi-approved'],
  },
  cube: { id: 'Cube', name: 'Cube License' },
  curl: { id: 'curl', name: 'curl License' },
  'd-fsl-1.0': { id: 'D-FSL-1.0', name: 'Deutsche Freie Software Lizenz' },
  'dec-3-clause': { id: 'DEC-3-Clause', name: 'DEC 3-Clause License' },
  diffmark: { id: 'diffmark', name: 'diffmark license' },
  'dl-de-by-2.0': {
    id: 'DL-DE-BY-2.0',
    name: 'Data licence Germany – attribution – version 2.0',
  },
  'dl-de-zero-2.0': {
    id: 'DL-DE-ZERO-2.0',
    name: 'Data licence Germany – zero – version 2.0',
  },
  doc: { id: 'DOC', name: 'DOC License' },
  dotseqn: { id: 'Dotseqn', name: 'Dotseqn License' },
  'drl-1.0': { id: 'DRL-1.0', name: 'Detection Rule License 1.0' },
  'drl-1.1': { id: 'DRL-1.1', name: 'Detection Rule License 1.1' },
  dsdp: { id: 'DSDP', name: 'DSDP License' },
  dtoa: { id: 'dtoa', name: 'David M. Gay dtoa License' },
  dvipdfm: { id: 'dvipdfm', name: 'dvipdfm License' },
  'ecl-1.0': {
    id: 'ECL-1.0',
    name: 'Educational Community License v1.0',
    isOsiApproved: true,
    keywords: ['discouraged', 'obsolete', 'osi-approved'],
  },
  'ecl-2.0': {
    id: 'ECL-2.0',
    name: 'Educational Community License v2.0',
    isOsiApproved: true,
    keywords: ['special-purpose', 'osi-approved'],
  },
  'ecos-2.0': {
    id: 'eCos-2.0',
    name: 'eCos license version 2.0',
    isDeprecatedLicenseId: true,
  },
  'efl-1.0': {
    id: 'EFL-1.0',
    name: 'Eiffel Forum License v1.0',
    isOsiApproved: true,
    keywords: ['osi-approved', 'discouraged', 'obsolete'],
  },
  'efl-2.0': {
    id: 'EFL-2.0',
    name: 'Eiffel Forum License v2.0',
    isOsiApproved: true,
    keywords: ['osi-approved', 'discouraged', 'redundant'],
  },
  egenix: { id: 'eGenix', name: 'eGenix.com Public License 1.1.0' },
  'elastic-2.0': { id: 'Elastic-2.0', name: 'Elastic License 2.0' },
  entessa: {
    id: 'Entessa',
    name: 'Entessa Public License v1.0',
    isOsiApproved: true,
    keywords: ['discouraged', 'non-reusable', 'osi-approved'],
  },
  epics: { id: 'EPICS', name: 'EPICS Open License' },
  'epl-1.0': {
    id: 'EPL-1.0',
    name: 'Eclipse Public License 1.0',
    isOsiApproved: true,
    keywords: ['osi-approved', 'popular'],
  },
  'epl-2.0': {
    id: 'EPL-2.0',
    name: 'Eclipse Public License 2.0',
    isOsiApproved: true,
  },
  'erlpl-1.1': { id: 'ErlPL-1.1', name: 'Erlang Public License v1.1' },
  'etalab-2.0': { id: 'etalab-2.0', name: 'Etalab Open License 2.0' },
  eudatagrid: {
    id: 'EUDatagrid',
    name: 'EU DataGrid Software License',
    isOsiApproved: true,
    keywords: ['discouraged', 'non-reusable', 'osi-approved'],
  },
  'eupl-1.0': { id: 'EUPL-1.0', name: 'European Union Public License 1.0' },
  'eupl-1.1': {
    id: 'EUPL-1.1',
    name: 'European Union Public License 1.1',
    isOsiApproved: true,
    keywords: ['osi-approved'],
  },
  'eupl-1.2': {
    id: 'EUPL-1.2',
    name: 'European Union Public License 1.2',
    isOsiApproved: true,
  },
  eurosym: { id: 'Eurosym', name: 'Eurosym License' },
  fair: {
    id: 'Fair',
    name: 'Fair License',
    isOsiApproved: true,
    keywords: ['osi-approved', 'discouraged', 'redundant'],
  },
  fbm: { id: 'FBM', name: 'Fuzzy Bitmap License' },
  'fdk-aac': { id: 'FDK-AAC', name: 'Fraunhofer FDK AAC Codec Library' },
  'ferguson-twofish': {
    id: 'Ferguson-Twofish',
    name: 'Ferguson Twofish License',
  },
  'frameworx-1.0': {
    id: 'Frameworx-1.0',
    name: 'Frameworx Open License 1.0',
    isOsiApproved: true,
    keywords: ['discouraged', 'non-reusable', 'osi-approved'],
  },
  'freebsd-doc': { id: 'FreeBSD-DOC', name: 'FreeBSD Documentation License' },
  freeimage: { id: 'FreeImage', name: 'FreeImage Public License v1.0' },
  fsfap: { id: 'FSFAP', name: 'FSF All Permissive License' },
  fsful: { id: 'FSFUL', name: 'FSF Unlimited License' },
  fsfullr: {
    id: 'FSFULLR',
    name: 'FSF Unlimited License (with License Retention)',
  },
  fsfullrwd: {
    id: 'FSFULLRWD',
    name: 'FSF Unlimited License (With License Retention and Warranty Disclaimer)',
  },
  ftl: { id: 'FTL', name: 'Freetype Project License' },
  furuseth: { id: 'Furuseth', name: 'Furuseth License' },
  fwlw: { id: 'fwlw', name: 'fwlw License' },
  'gcr-docs': { id: 'GCR-docs', name: 'Gnome GCR Documentation License' },
  gd: { id: 'GD', name: 'GD License' },
  'gfdl-1.1': {
    id: 'GFDL-1.1',
    name: 'GNU Free Documentation License v1.1',
    isDeprecatedLicenseId: true,
  },
  'gfdl-1.1-invariants-only': {
    id: 'GFDL-1.1-invariants-only',
    name: 'GNU Free Documentation License v1.1 only - invariants',
  },
  'gfdl-1.1-invariants-or-later': {
    id: 'GFDL-1.1-invariants-or-later',
    name: 'GNU Free Documentation License v1.1 or later - invariants',
  },
  'gfdl-1.1-no-invariants-only': {
    id: 'GFDL-1.1-no-invariants-only',
    name: 'GNU Free Documentation License v1.1 only - no invariants',
  },
  'gfdl-1.1-no-invariants-or-later': {
    id: 'GFDL-1.1-no-invariants-or-later',
    name: 'GNU Free Documentation License v1.1 or later - no invariants',
  },
  'gfdl-1.1-only': {
    id: 'GFDL-1.1-only',
    name: 'GNU Free Documentation License v1.1 only',
  },
  'gfdl-1.1-or-later': {
    id: 'GFDL-1.1-or-later',
    name: 'GNU Free Documentation License v1.1 or later',
  },
  'gfdl-1.2': {
    id: 'GFDL-1.2',
    name: 'GNU Free Documentation License v1.2',
    isDeprecatedLicenseId: true,
  },
  'gfdl-1.2-invariants-only': {
    id: 'GFDL-1.2-invariants-only',
    name: 'GNU Free Documentation License v1.2 only - invariants',
  },
  'gfdl-1.2-invariants-or-later': {
    id: 'GFDL-1.2-invariants-or-later',
    name: 'GNU Free Documentation License v1.2 or later - invariants',
  },
  'gfdl-1.2-no-invariants-only': {
    id: 'GFDL-1.2-no-invariants-only',
    name: 'GNU Free Documentation License v1.2 only - no invariants',
  },
  'gfdl-1.2-no-invariants-or-later': {
    id: 'GFDL-1.2-no-invariants-or-later',
    name: 'GNU Free Documentation License v1.2 or later - no invariants',
  },
  'gfdl-1.2-only': {
    id: 'GFDL-1.2-only',
    name: 'GNU Free Documentation License v1.2 only',
  },
  'gfdl-1.2-or-later': {
    id: 'GFDL-1.2-or-later',
    name: 'GNU Free Documentation License v1.2 or later',
  },
  'gfdl-1.3': {
    id: 'GFDL-1.3',
    name: 'GNU Free Documentation License v1.3',
    isDeprecatedLicenseId: true,
  },
  'gfdl-1.3-invariants-only': {
    id: 'GFDL-1.3-invariants-only',
    name: 'GNU Free Documentation License v1.3 only - invariants',
  },
  'gfdl-1.3-invariants-or-later': {
    id: 'GFDL-1.3-invariants-or-later',
    name: 'GNU Free Documentation License v1.3 or later - invariants',
  },
  'gfdl-1.3-no-invariants-only': {
    id: 'GFDL-1.3-no-invariants-only',
    name: 'GNU Free Documentation License v1.3 only - no invariants',
  },
  'gfdl-1.3-no-invariants-or-later': {
    id: 'GFDL-1.3-no-invariants-or-later',
    name: 'GNU Free Documentation License v1.3 or later - no invariants',
  },
  'gfdl-1.3-only': {
    id: 'GFDL-1.3-only',
    name: 'GNU Free Documentation License v1.3 only',
  },
  'gfdl-1.3-or-later': {
    id: 'GFDL-1.3-or-later',
    name: 'GNU Free Documentation License v1.3 or later',
  },
  giftware: { id: 'Giftware', name: 'Giftware License' },
  gl2ps: { id: 'GL2PS', name: 'GL2PS License' },
  glide: { id: 'Glide', name: '3dfx Glide License' },
  glulxe: { id: 'Glulxe', name: 'Glulxe License' },
  glwtpl: { id: 'GLWTPL', name: 'Good Luck With That Public License' },
  gnuplot: { id: 'gnuplot', name: 'gnuplot License' },
  'gpl-1.0': {
    id: 'GPL-1.0',
    name: 'GNU General Public License v1.0 only',
    isDeprecatedLicenseId: true,
  },
  'gpl-1.0+': {
    id: 'GPL-1.0+',
    name: 'GNU General Public License v1.0 or later',
    isDeprecatedLicenseId: true,
  },
  'gpl-1.0-only': {
    id: 'GPL-1.0-only',
    name: 'GNU General Public License v1.0 only',
  },
  'gpl-1.0-or-later': {
    id: 'GPL-1.0-or-later',
    name: 'GNU General Public License v1.0 or later',
  },
  'gpl-2.0': {
    id: 'GPL-2.0',
    name: 'GNU General Public License v2.0 only',
    isOsiApproved: true,
    isDeprecatedLicenseId: true,
    keywords: ['osi-approved', 'popular', 'copyleft'],
  },
  'gpl-2.0+': {
    id: 'GPL-2.0+',
    name: 'GNU General Public License v2.0 or later',
    isOsiApproved: true,
    isDeprecatedLicenseId: true,
  },
  'gpl-2.0-only': {
    id: 'GPL-2.0-only',
    name: 'GNU General Public License v2.0 only',
    isOsiApproved: true,
  },
  'gpl-2.0-or-later': {
    id: 'GPL-2.0-or-later',
    name: 'GNU General Public License v2.0 or later',
    isOsiApproved: true,
  },
  'gpl-2.0-with-autoconf-exception': {
    id: 'GPL-2.0-with-autoconf-exception',
    name: 'GNU General Public License v2.0 w/Autoconf exception',
    isDeprecatedLicenseId: true,
  },
  'gpl-2.0-with-bison-exception': {
    id: 'GPL-2.0-with-bison-exception',
    name: 'GNU General Public License v2.0 w/Bison exception',
    isDeprecatedLicenseId: true,
  },
  'gpl-2.0-with-classpath-exception': {
    id: 'GPL-2.0-with-classpath-exception',
    name: 'GNU General Public License v2.0 w/Classpath exception',
    isDeprecatedLicenseId: true,
  },
  'gpl-2.0-with-font-exception': {
    id: 'GPL-2.0-with-font-exception',
    name: 'GNU General Public License v2.0 w/Font exception',
    isDeprecatedLicenseId: true,
  },
  'gpl-2.0-with-gcc-exception': {
    id: 'GPL-2.0-with-GCC-exception',
    name: 'GNU General Public License v2.0 w/GCC Runtime Library exception',
    isDeprecatedLicenseId: true,
  },
  'gpl-3.0': {
    id: 'GPL-3.0',
    name: 'GNU General Public License v3.0 only',
    isOsiApproved: true,
    isDeprecatedLicenseId: true,
    keywords: ['osi-approved', 'popular', 'copyleft'],
  },
  'gpl-3.0+': {
    id: 'GPL-3.0+',
    name: 'GNU General Public License v3.0 or later',
    isOsiApproved: true,
    isDeprecatedLicenseId: true,
  },
  'gpl-3.0-only': {
    id: 'GPL-3.0-only',
    name: 'GNU General Public License v3.0 only',
    isOsiApproved: true,
  },
  'gpl-3.0-or-later': {
    id: 'GPL-3.0-or-later',
    name: 'GNU General Public License v3.0 or later',
    isOsiApproved: true,
  },
  'gpl-3.0-with-autoconf-exception': {
    id: 'GPL-3.0-with-autoconf-exception',
    name: 'GNU General Public License v3.0 w/Autoconf exception',
    isDeprecatedLicenseId: true,
  },
  'gpl-3.0-with-gcc-exception': {
    id: 'GPL-3.0-with-GCC-exception',
    name: 'GNU General Public License v3.0 w/GCC Runtime Library exception',
    isOsiApproved: true,
    isDeprecatedLicenseId: true,
  },
  'graphics-gems': { id: 'Graphics-Gems', name: 'Graphics Gems License' },
  'gsoap-1.3b': { id: 'gSOAP-1.3b', name: 'gSOAP Public License v1.3b' },
  haskellreport: {
    id: 'HaskellReport',
    name: 'Haskell Language Report License',
  },
  hdparm: { id: 'hdparm', name: 'hdparm License' },
  'hippocratic-2.1': { id: 'Hippocratic-2.1', name: 'Hippocratic License 2.1' },
  'hp-1986': { id: 'HP-1986', name: 'Hewlett-Packard 1986 License' },
  'hp-1989': { id: 'HP-1989', name: 'Hewlett-Packard 1989 License' },
  hpnd: {
    id: 'HPND',
    name: 'Historical Permission Notice and Disclaimer',
    isOsiApproved: true,
    keywords: ['osi-approved', 'discouraged', 'redundant'],
  },
  'hpnd-dec': {
    id: 'HPND-DEC',
    name: 'Historical Permission Notice and Disclaimer - DEC variant',
  },
  'hpnd-doc': {
    id: 'HPND-doc',
    name: 'Historical Permission Notice and Disclaimer - documentation variant',
  },
  'hpnd-doc-sell': {
    id: 'HPND-doc-sell',
    name: 'Historical Permission Notice and Disclaimer - documentation sell variant',
  },
  'hpnd-export-us': {
    id: 'HPND-export-US',
    name: 'HPND with US Government export control warning',
  },
  'hpnd-export-us-modify': {
    id: 'HPND-export-US-modify',
    name: 'HPND with US Government export control warning and modification rqmt',
  },
  'hpnd-markus-kuhn': {
    id: 'HPND-Markus-Kuhn',
    name: 'Historical Permission Notice and Disclaimer - Markus Kuhn variant',
  },
  'hpnd-pbmplus': {
    id: 'HPND-Pbmplus',
    name: 'Historical Permission Notice and Disclaimer - Pbmplus variant',
  },
  'hpnd-sell-mit-disclaimer-xserver': {
    id: 'HPND-sell-MIT-disclaimer-xserver',
    name: 'Historical Permission Notice and Disclaimer - sell xserver variant with MIT disclaimer',
  },
  'hpnd-sell-regexpr': {
    id: 'HPND-sell-regexpr',
    name: 'Historical Permission Notice and Disclaimer - sell regexpr variant',
  },
  'hpnd-sell-variant': {
    id: 'HPND-sell-variant',
    name: 'Historical Permission Notice and Disclaimer - sell variant',
  },
  'hpnd-sell-variant-mit-disclaimer': {
    id: 'HPND-sell-variant-MIT-disclaimer',
    name: 'HPND sell variant with MIT disclaimer',
  },
  'hpnd-uc': {
    id: 'HPND-UC',
    name: 'Historical Permission Notice and Disclaimer - University of California variant',
  },
  htmltidy: { id: 'HTMLTIDY', name: 'HTML Tidy License' },
  'ibm-pibs': {
    id: 'IBM-pibs',
    name: 'IBM PowerPC Initialization and Boot Software',
  },
  icu: { id: 'ICU', name: 'ICU License', isOsiApproved: true },
  'iec-code-components-eula': {
    id: 'IEC-Code-Components-EULA',
    name: 'IEC    Code Components End-user licence agreement',
  },
  ijg: { id: 'IJG', name: 'Independent JPEG Group License' },
  'ijg-short': {
    id: 'IJG-short',
    name: 'Independent JPEG Group License - short',
  },
  imagemagick: { id: 'ImageMagick', name: 'ImageMagick License' },
  imatix: { id: 'iMatix', name: 'iMatix Standard Function Library Agreement' },
  imlib2: { id: 'Imlib2', name: 'Imlib2 License' },
  'info-zip': { id: 'Info-ZIP', name: 'Info-ZIP License' },
  'inner-net-2.0': { id: 'Inner-Net-2.0', name: 'Inner Net License v2.0' },
  intel: {
    id: 'Intel',
    name: 'Intel Open Source License',
    isOsiApproved: true,
    keywords: ['discouraged', 'retired', 'osi-approved'],
  },
  'intel-acpi': {
    id: 'Intel-ACPI',
    name: 'Intel ACPI Software License Agreement',
  },
  'interbase-1.0': {
    id: 'Interbase-1.0',
    name: 'Interbase Public License v1.0',
  },
  ipa: {
    id: 'IPA',
    name: 'IPA Font License',
    isOsiApproved: true,
    keywords: ['osi-approved', 'special-purpose'],
  },
  'ipl-1.0': {
    id: 'IPL-1.0',
    name: 'IBM Public License v1.0',
    isOsiApproved: true,
    keywords: ['discouraged', 'non-reusable', 'osi-approved'],
  },
  isc: {
    id: 'ISC',
    name: 'ISC License',
    isOsiApproved: true,
    keywords: ['osi-approved'],
  },
  jam: { id: 'Jam', name: 'Jam License', isOsiApproved: true },
  'jasper-2.0': { id: 'JasPer-2.0', name: 'JasPer License' },
  'jpl-image': { id: 'JPL-image', name: 'JPL Image Use Policy' },
  jpnic: { id: 'JPNIC', name: 'Japan Network Information Center License' },
  json: { id: 'JSON', name: 'JSON License' },
  kastrup: { id: 'Kastrup', name: 'Kastrup License' },
  kazlib: { id: 'Kazlib', name: 'Kazlib License' },
  'knuth-ctan': { id: 'Knuth-CTAN', name: 'Knuth CTAN License' },
  'lal-1.2': { id: 'LAL-1.2', name: 'Licence Art Libre 1.2' },
  'lal-1.3': { id: 'LAL-1.3', name: 'Licence Art Libre 1.3' },
  latex2e: { id: 'Latex2e', name: 'Latex2e License' },
  'latex2e-translated-notice': {
    id: 'Latex2e-translated-notice',
    name: 'Latex2e with translated notice permission',
  },
  leptonica: { id: 'Leptonica', name: 'Leptonica License' },
  'lgpl-2.0': {
    id: 'LGPL-2.0',
    name: 'GNU Library General Public License v2 only',
    isOsiApproved: true,
    isDeprecatedLicenseId: true,
  },
  'lgpl-2.0+': {
    id: 'LGPL-2.0+',
    name: 'GNU Library General Public License v2 or later',
    isOsiApproved: true,
    isDeprecatedLicenseId: true,
  },
  'lgpl-2.0-only': {
    id: 'LGPL-2.0-only',
    name: 'GNU Library General Public License v2 only',
    isOsiApproved: true,
  },
  'lgpl-2.0-or-later': {
    id: 'LGPL-2.0-or-later',
    name: 'GNU Library General Public License v2 or later',
    isOsiApproved: true,
  },
  'lgpl-2.1': {
    id: 'LGPL-2.1',
    name: 'GNU Lesser General Public License v2.1 only',
    isOsiApproved: true,
    isDeprecatedLicenseId: true,
    keywords: ['osi-approved', 'popular', 'copyleft'],
  },
  'lgpl-2.1+': {
    id: 'LGPL-2.1+',
    name: 'GNU Lesser General Public License v2.1 or later',
    isOsiApproved: true,
    isDeprecatedLicenseId: true,
  },
  'lgpl-2.1-only': {
    id: 'LGPL-2.1-only',
    name: 'GNU Lesser General Public License v2.1 only',
    isOsiApproved: true,
  },
  'lgpl-2.1-or-later': {
    id: 'LGPL-2.1-or-later',
    name: 'GNU Lesser General Public License v2.1 or later',
    isOsiApproved: true,
  },
  'lgpl-3.0': {
    id: 'LGPL-3.0',
    name: 'GNU Lesser General Public License v3.0 only',
    isOsiApproved: true,
    isDeprecatedLicenseId: true,
    keywords: ['osi-approved', 'popular', 'copyleft'],
  },
  'lgpl-3.0+': {
    id: 'LGPL-3.0+',
    name: 'GNU Lesser General Public License v3.0 or later',
    isOsiApproved: true,
    isDeprecatedLicenseId: true,
  },
  'lgpl-3.0-only': {
    id: 'LGPL-3.0-only',
    name: 'GNU Lesser General Public License v3.0 only',
    isOsiApproved: true,
  },
  'lgpl-3.0-or-later': {
    id: 'LGPL-3.0-or-later',
    name: 'GNU Lesser General Public License v3.0 or later',
    isOsiApproved: true,
  },
  lgpllr: {
    id: 'LGPLLR',
    name: 'Lesser General Public License For Linguistic Resources',
  },
  libpng: { id: 'Libpng', name: 'libpng License' },
  'libpng-2.0': { id: 'libpng-2.0', name: 'PNG Reference Library version 2' },
  'libselinux-1.0': {
    id: 'libselinux-1.0',
    name: 'libselinux public domain notice',
  },
  libtiff: { id: 'libtiff', name: 'libtiff License' },
  'libutil-david-nugent': {
    id: 'libutil-David-Nugent',
    name: 'libutil David Nugent License',
  },
  'liliq-p-1.1': {
    id: 'LiLiQ-P-1.1',
    name: 'Licence Libre du Québec – Permissive version 1.1',
    isOsiApproved: true,
  },
  'liliq-r-1.1': {
    id: 'LiLiQ-R-1.1',
    name: 'Licence Libre du Québec – Réciprocité version 1.1',
    isOsiApproved: true,
  },
  'liliq-rplus-1.1': {
    id: 'LiLiQ-Rplus-1.1',
    name: 'Licence Libre du Québec – Réciprocité forte version 1.1',
    isOsiApproved: true,
  },
  'linux-man-pages-1-para': {
    id: 'Linux-man-pages-1-para',
    name: 'Linux man-pages - 1 paragraph',
  },
  'linux-man-pages-copyleft': {
    id: 'Linux-man-pages-copyleft',
    name: 'Linux man-pages Copyleft',
  },
  'linux-man-pages-copyleft-2-para': {
    id: 'Linux-man-pages-copyleft-2-para',
    name: 'Linux man-pages Copyleft - 2 paragraphs',
  },
  'linux-man-pages-copyleft-var': {
    id: 'Linux-man-pages-copyleft-var',
    name: 'Linux man-pages Copyleft Variant',
  },
  'linux-openib': {
    id: 'Linux-OpenIB',
    name: 'Linux Kernel Variant of OpenIB.org license',
  },
  loop: { id: 'LOOP', name: 'Common Lisp LOOP License' },
  'lpl-1.0': {
    id: 'LPL-1.0',
    name: 'Lucent Public License Version 1.0',
    isOsiApproved: true,
    keywords: ['osi-approved', 'discouraged', 'obsolete'],
  },
  'lpl-1.02': {
    id: 'LPL-1.02',
    name: 'Lucent Public License v1.02',
    isOsiApproved: true,
    keywords: ['osi-approved', 'discouraged', 'redundant'],
  },
  'lppl-1.0': { id: 'LPPL-1.0', name: 'LaTeX Project Public License v1.0' },
  'lppl-1.1': { id: 'LPPL-1.1', name: 'LaTeX Project Public License v1.1' },
  'lppl-1.2': { id: 'LPPL-1.2', name: 'LaTeX Project Public License v1.2' },
  'lppl-1.3a': { id: 'LPPL-1.3a', name: 'LaTeX Project Public License v1.3a' },
  'lppl-1.3c': {
    id: 'LPPL-1.3c',
    name: 'LaTeX Project Public License v1.3c',
    isOsiApproved: true,
    keywords: ['discouraged', 'non-reusable', 'osi-approved'],
  },
  lsof: { id: 'lsof', name: 'lsof License' },
  'lucida-bitmap-fonts': {
    id: 'Lucida-Bitmap-Fonts',
    name: 'Lucida Bitmap Fonts License',
  },
  'lzma-sdk-9.11-to-9.20': {
    id: 'LZMA-SDK-9.11-to-9.20',
    name: 'LZMA SDK License (versions 9.11 to 9.20)',
  },
  'lzma-sdk-9.22': {
    id: 'LZMA-SDK-9.22',
    name: 'LZMA SDK License (versions 9.22 and beyond)',
  },
  magaz: { id: 'magaz', name: 'magaz License' },
  makeindex: { id: 'MakeIndex', name: 'MakeIndex License' },
  'martin-birgmeier': {
    id: 'Martin-Birgmeier',
    name: 'Martin Birgmeier License',
  },
  'mcphee-slideshow': {
    id: 'McPhee-slideshow',
    name: 'McPhee Slideshow License',
  },
  metamail: { id: 'metamail', name: 'metamail License' },
  minpack: { id: 'Minpack', name: 'Minpack License' },
  miros: {
    id: 'MirOS',
    name: 'The MirOS Licence',
    isOsiApproved: true,
    keywords: ['osi-approved'],
  },
  mit: {
    id: 'MIT',
    name: 'MIT License',
    isOsiApproved: true,
    keywords: ['osi-approved', 'popular', 'permissive'],
  },
  'mit-0': { id: 'MIT-0', name: 'MIT No Attribution', isOsiApproved: true },
  'mit-advertising': {
    id: 'MIT-advertising',
    name: 'Enlightenment License (e16)',
  },
  'mit-cmu': { id: 'MIT-CMU', name: 'CMU License' },
  'mit-enna': { id: 'MIT-enna', name: 'enna License' },
  'mit-feh': { id: 'MIT-feh', name: 'feh License' },
  'mit-festival': { id: 'MIT-Festival', name: 'MIT Festival Variant' },
  'mit-modern-variant': {
    id: 'MIT-Modern-Variant',
    name: 'MIT License Modern Variant',
    isOsiApproved: true,
  },
  'mit-open-group': { id: 'MIT-open-group', name: 'MIT Open Group variant' },
  'mit-testregex': { id: 'MIT-testregex', name: 'MIT testregex Variant' },
  'mit-wu': { id: 'MIT-Wu', name: 'MIT Tom Wu Variant' },
  mitnfa: { id: 'MITNFA', name: 'MIT +no-false-attribs license' },
  mmixware: { id: 'MMIXware', name: 'MMIXware License' },
  motosoto: {
    id: 'Motosoto',
    name: 'Motosoto License',
    isOsiApproved: true,
    keywords: ['discouraged', 'non-reusable', 'osi-approved'],
  },
  'mpeg-ssg': { id: 'MPEG-SSG', name: 'MPEG Software Simulation' },
  'mpi-permissive': { id: 'mpi-permissive', name: 'mpi Permissive License' },
  mpich2: { id: 'mpich2', name: 'mpich2 License' },
  'mpl-1.0': {
    id: 'MPL-1.0',
    name: 'Mozilla Public License 1.0',
    isOsiApproved: true,
    keywords: ['osi-approved', 'discouraged', 'obsolete'],
  },
  'mpl-1.1': {
    id: 'MPL-1.1',
    name: 'Mozilla Public License 1.1',
    isOsiApproved: true,
    keywords: ['osi-approved', 'discouraged', 'obsolete'],
  },
  'mpl-2.0': {
    id: 'MPL-2.0',
    name: 'Mozilla Public License 2.0',
    isOsiApproved: true,
    keywords: ['osi-approved', 'popular', 'copyleft'],
  },
  'mpl-2.0-no-copyleft-exception': {
    id: 'MPL-2.0-no-copyleft-exception',
    name: 'Mozilla Public License 2.0 (no copyleft exception)',
    isOsiApproved: true,
  },
  mplus: { id: 'mplus', name: 'mplus Font License' },
  'ms-lpl': { id: 'MS-LPL', name: 'Microsoft Limited Public License' },
  'ms-pl': {
    id: 'MS-PL',
    name: 'Microsoft Public License',
    isOsiApproved: true,
    keywords: ['osi-approved'],
  },
  'ms-rl': {
    id: 'MS-RL',
    name: 'Microsoft Reciprocal License',
    isOsiApproved: true,
    keywords: ['osi-approved'],
  },
  mtll: { id: 'MTLL', name: 'Matrix Template Library License' },
  'mulanpsl-1.0': {
    id: 'MulanPSL-1.0',
    name: 'Mulan Permissive Software License, Version 1',
  },
  'mulanpsl-2.0': {
    id: 'MulanPSL-2.0',
    name: 'Mulan Permissive Software License, Version 2',
    isOsiApproved: true,
  },
  multics: {
    id: 'Multics',
    name: 'Multics License',
    isOsiApproved: true,
    keywords: ['discouraged', 'non-reusable', 'osi-approved'],
  },
  mup: { id: 'Mup', name: 'Mup License' },
  'naist-2003': {
    id: 'NAIST-2003',
    name: 'Nara Institute of Science and Technology License (2003)',
  },
  'nasa-1.3': {
    id: 'NASA-1.3',
    name: 'NASA Open Source Agreement 1.3',
    isOsiApproved: true,
    keywords: ['osi-approved', 'special-purpose'],
  },
  naumen: {
    id: 'Naumen',
    name: 'Naumen Public License',
    isOsiApproved: true,
    keywords: ['discouraged', 'non-reusable', 'osi-approved'],
  },
  'nbpl-1.0': { id: 'NBPL-1.0', name: 'Net Boolean Public License v1' },
  'ncgl-uk-2.0': {
    id: 'NCGL-UK-2.0',
    name: 'Non-Commercial Government Licence',
  },
  ncsa: {
    id: 'NCSA',
    name: 'University of Illinois/NCSA Open Source License',
    isOsiApproved: true,
    keywords: ['osi-approved', 'discouraged', 'redundant'],
  },
  'net-snmp': { id: 'Net-SNMP', name: 'Net-SNMP License' },
  netcdf: { id: 'NetCDF', name: 'NetCDF license' },
  newsletr: { id: 'Newsletr', name: 'Newsletr License' },
  ngpl: {
    id: 'NGPL',
    name: 'Nethack General Public License',
    isOsiApproved: true,
    keywords: ['discouraged', 'non-reusable', 'osi-approved'],
  },
  'nicta-1.0': {
    id: 'NICTA-1.0',
    name: 'NICTA Public Software License, Version 1.0',
  },
  'nist-pd': { id: 'NIST-PD', name: 'NIST Public Domain Notice' },
  'nist-pd-fallback': {
    id: 'NIST-PD-fallback',
    name: 'NIST Public Domain Notice with license fallback',
  },
  'nist-software': { id: 'NIST-Software', name: 'NIST Software License' },
  'nlod-1.0': {
    id: 'NLOD-1.0',
    name: 'Norwegian Licence for Open Government Data (NLOD) 1.0',
  },
  'nlod-2.0': {
    id: 'NLOD-2.0',
    name: 'Norwegian Licence for Open Government Data (NLOD) 2.0',
  },
  nlpl: { id: 'NLPL', name: 'No Limit Public License' },
  nokia: {
    id: 'Nokia',
    name: 'Nokia Open Source License',
    isOsiApproved: true,
    keywords: ['discouraged', 'non-reusable', 'osi-approved'],
  },
  nosl: { id: 'NOSL', name: 'Netizen Open Source License' },
  noweb: { id: 'Noweb', name: 'Noweb License' },
  'npl-1.0': { id: 'NPL-1.0', name: 'Netscape Public License v1.0' },
  'npl-1.1': { id: 'NPL-1.1', name: 'Netscape Public License v1.1' },
  'nposl-3.0': {
    id: 'NPOSL-3.0',
    name: 'Non-Profit Open Software License 3.0',
    isOsiApproved: true,
    keywords: ['osi-approved'],
  },
  nrl: { id: 'NRL', name: 'NRL License' },
  ntp: {
    id: 'NTP',
    name: 'NTP License',
    isOsiApproved: true,
    keywords: ['osi-approved'],
  },
  'ntp-0': { id: 'NTP-0', name: 'NTP No Attribution' },
  nunit: { id: 'Nunit', name: 'Nunit License', isDeprecatedLicenseId: true },
  'o-uda-1.0': { id: 'O-UDA-1.0', name: 'Open Use of Data Agreement v1.0' },
  'occt-pl': { id: 'OCCT-PL', name: 'Open CASCADE Technology Public License' },
  'oclc-2.0': {
    id: 'OCLC-2.0',
    name: 'OCLC Research Public License 2.0',
    isOsiApproved: true,
    keywords: ['discouraged', 'non-reusable', 'osi-approved'],
  },
  'odbl-1.0': {
    id: 'ODbL-1.0',
    name: 'Open Data Commons Open Database License v1.0',
  },
  'odc-by-1.0': {
    id: 'ODC-By-1.0',
    name: 'Open Data Commons Attribution License v1.0',
  },
  offis: { id: 'OFFIS', name: 'OFFIS License' },
  'ofl-1.0': { id: 'OFL-1.0', name: 'SIL Open Font License 1.0' },
  'ofl-1.0-no-rfn': {
    id: 'OFL-1.0-no-RFN',
    name: 'SIL Open Font License 1.0 with no Reserved Font Name',
  },
  'ofl-1.0-rfn': {
    id: 'OFL-1.0-RFN',
    name: 'SIL Open Font License 1.0 with Reserved Font Name',
  },
  'ofl-1.1': {
    id: 'OFL-1.1',
    name: 'SIL Open Font License 1.1',
    isOsiApproved: true,
    keywords: ['osi-approved', 'special-purpose'],
  },
  'ofl-1.1-no-rfn': {
    id: 'OFL-1.1-no-RFN',
    name: 'SIL Open Font License 1.1 with no Reserved Font Name',
    isOsiApproved: true,
  },
  'ofl-1.1-rfn': {
    id: 'OFL-1.1-RFN',
    name: 'SIL Open Font License 1.1 with Reserved Font Name',
    isOsiApproved: true,
  },
  'ogc-1.0': { id: 'OGC-1.0', name: 'OGC Software License, Version 1.0' },
  'ogdl-taiwan-1.0': {
    id: 'OGDL-Taiwan-1.0',
    name: 'Taiwan Open Government Data License, version 1.0',
  },
  'ogl-canada-2.0': {
    id: 'OGL-Canada-2.0',
    name: 'Open Government Licence - Canada',
  },
  'ogl-uk-1.0': { id: 'OGL-UK-1.0', name: 'Open Government Licence v1.0' },
  'ogl-uk-2.0': { id: 'OGL-UK-2.0', name: 'Open Government Licence v2.0' },
  'ogl-uk-3.0': { id: 'OGL-UK-3.0', name: 'Open Government Licence v3.0' },
  ogtsl: {
    id: 'OGTSL',
    name: 'Open Group Test Suite License',
    isOsiApproved: true,
    keywords: ['osi-approved'],
  },
  'oldap-1.1': { id: 'OLDAP-1.1', name: 'Open LDAP Public License v1.1' },
  'oldap-1.2': { id: 'OLDAP-1.2', name: 'Open LDAP Public License v1.2' },
  'oldap-1.3': { id: 'OLDAP-1.3', name: 'Open LDAP Public License v1.3' },
  'oldap-1.4': { id: 'OLDAP-1.4', name: 'Open LDAP Public License v1.4' },
  'oldap-2.0': {
    id: 'OLDAP-2.0',
    name: 'Open LDAP Public License v2.0 (or possibly 2.0A and 2.0B)',
  },
  'oldap-2.0.1': { id: 'OLDAP-2.0.1', name: 'Open LDAP Public License v2.0.1' },
  'oldap-2.1': { id: 'OLDAP-2.1', name: 'Open LDAP Public License v2.1' },
  'oldap-2.2': { id: 'OLDAP-2.2', name: 'Open LDAP Public License v2.2' },
  'oldap-2.2.1': { id: 'OLDAP-2.2.1', name: 'Open LDAP Public License v2.2.1' },
  'oldap-2.2.2': { id: 'OLDAP-2.2.2', name: 'Open LDAP Public License 2.2.2' },
  'oldap-2.3': { id: 'OLDAP-2.3', name: 'Open LDAP Public License v2.3' },
  'oldap-2.4': { id: 'OLDAP-2.4', name: 'Open LDAP Public License v2.4' },
  'oldap-2.5': { id: 'OLDAP-2.5', name: 'Open LDAP Public License v2.5' },
  'oldap-2.6': { id: 'OLDAP-2.6', name: 'Open LDAP Public License v2.6' },
  'oldap-2.7': { id: 'OLDAP-2.7', name: 'Open LDAP Public License v2.7' },
  'oldap-2.8': {
    id: 'OLDAP-2.8',
    name: 'Open LDAP Public License v2.8',
    isOsiApproved: true,
  },
  'olfl-1.3': {
    id: 'OLFL-1.3',
    name: 'Open Logistics Foundation License Version 1.3',
    isOsiApproved: true,
  },
  oml: { id: 'OML', name: 'Open Market License' },
  'openpbs-2.3': { id: 'OpenPBS-2.3', name: 'OpenPBS v2.3 Software License' },
  openssl: { id: 'OpenSSL', name: 'OpenSSL License' },
  'opl-1.0': { id: 'OPL-1.0', name: 'Open Public License v1.0' },
  'opl-uk-3.0': {
    id: 'OPL-UK-3.0',
    name: 'United    Kingdom Open Parliament Licence v3.0',
  },
  'opubl-1.0': { id: 'OPUBL-1.0', name: 'Open Publication License v1.0' },
  'oset-pl-2.1': {
    id: 'OSET-PL-2.1',
    name: 'OSET Public License version 2.1',
    isOsiApproved: true,
  },
  'osl-1.0': {
    id: 'OSL-1.0',
    name: 'Open Software License 1.0',
    isOsiApproved: true,
    keywords: ['osi-approved', 'discouraged', 'redundant'],
  },
  'osl-1.1': { id: 'OSL-1.1', name: 'Open Software License 1.1' },
  'osl-2.0': {
    id: 'OSL-2.0',
    name: 'Open Software License 2.0',
    isOsiApproved: true,
  },
  'osl-2.1': {
    id: 'OSL-2.1',
    name: 'Open Software License 2.1',
    isOsiApproved: true,
    keywords: ['osi-approved', 'discouraged', 'redundant'],
  },
  'osl-3.0': {
    id: 'OSL-3.0',
    name: 'Open Software License 3.0',
    isOsiApproved: true,
    keywords: ['osi-approved', 'miscellaneous'],
  },
  padl: { id: 'PADL', name: 'PADL License' },
  'parity-6.0.0': {
    id: 'Parity-6.0.0',
    name: 'The Parity Public License 6.0.0',
  },
  'parity-7.0.0': {
    id: 'Parity-7.0.0',
    name: 'The Parity Public License 7.0.0',
  },
  'pddl-1.0': {
    id: 'PDDL-1.0',
    name: 'Open Data Commons Public Domain Dedication & License 1.0',
  },
  'php-3.0': {
    id: 'PHP-3.0',
    name: 'PHP License v3.0',
    isOsiApproved: true,
    keywords: ['discouraged', 'non-reusable', 'osi-approved'],
  },
  'php-3.01': {
    id: 'PHP-3.01',
    name: 'PHP License v3.01',
    isOsiApproved: true,
  },
  pixar: { id: 'Pixar', name: 'Pixar License' },
  plexus: { id: 'Plexus', name: 'Plexus Classworlds License' },
  pnmstitch: { id: 'pnmstitch', name: 'pnmstitch License' },
  'polyform-noncommercial-1.0.0': {
    id: 'PolyForm-Noncommercial-1.0.0',
    name: 'PolyForm Noncommercial License 1.0.0',
  },
  'polyform-small-business-1.0.0': {
    id: 'PolyForm-Small-Business-1.0.0',
    name: 'PolyForm Small Business License 1.0.0',
  },
  postgresql: {
    id: 'PostgreSQL',
    name: 'PostgreSQL License',
    isOsiApproved: true,
    keywords: ['osi-approved', 'discouraged', 'redundant'],
  },
  'psf-2.0': { id: 'PSF-2.0', name: 'Python Software Foundation License 2.0' },
  psfrag: { id: 'psfrag', name: 'psfrag License' },
  psutils: { id: 'psutils', name: 'psutils License' },
  'python-2.0': {
    id: 'Python-2.0',
    name: 'Python License 2.0',
    isOsiApproved: true,
    keywords: ['discouraged', 'non-reusable', 'osi-approved'],
  },
  'python-2.0.1': { id: 'Python-2.0.1', name: 'Python License 2.0.1' },
  'python-ldap': { id: 'python-ldap', name: 'Python ldap License' },
  qhull: { id: 'Qhull', name: 'Qhull License' },
  'qpl-1.0': {
    id: 'QPL-1.0',
    name: 'Q Public License 1.0',
    isOsiApproved: true,
    keywords: ['osi-approved'],
  },
  'qpl-1.0-inria-2004': {
    id: 'QPL-1.0-INRIA-2004',
    name: 'Q Public License 1.0 - INRIA 2004 variant',
  },
  rdisc: { id: 'Rdisc', name: 'Rdisc License' },
  'rhecos-1.1': { id: 'RHeCos-1.1', name: 'Red Hat eCos Public License v1.1' },
  'rpl-1.1': {
    id: 'RPL-1.1',
    name: 'Reciprocal Public License 1.1',
    isOsiApproved: true,
    keywords: ['discouraged', 'obsolete', 'osi-approved'],
  },
  'rpl-1.5': {
    id: 'RPL-1.5',
    name: 'Reciprocal Public License 1.5',
    isOsiApproved: true,
    keywords: ['osi-approved'],
  },
  'rpsl-1.0': {
    id: 'RPSL-1.0',
    name: 'RealNetworks Public Source License v1.0',
    isOsiApproved: true,
    keywords: ['discouraged', 'non-reusable', 'osi-approved'],
  },
  'rsa-md': { id: 'RSA-MD', name: 'RSA Message-Digest License' },
  rscpl: {
    id: 'RSCPL',
    name: 'Ricoh Source Code Public License',
    isOsiApproved: true,
    keywords: ['discouraged', 'non-reusable', 'osi-approved'],
  },
  ruby: { id: 'Ruby', name: 'Ruby License' },
  'sax-pd': { id: 'SAX-PD', name: 'Sax Public Domain Notice' },
  saxpath: { id: 'Saxpath', name: 'Saxpath License' },
  scea: { id: 'SCEA', name: 'SCEA Shared Source License' },
  schemereport: { id: 'SchemeReport', name: 'Scheme Language Report License' },
  sendmail: { id: 'Sendmail', name: 'Sendmail License' },
  'sendmail-8.23': { id: 'Sendmail-8.23', name: 'Sendmail License 8.23' },
  'sgi-b-1.0': { id: 'SGI-B-1.0', name: 'SGI Free Software License B v1.0' },
  'sgi-b-1.1': { id: 'SGI-B-1.1', name: 'SGI Free Software License B v1.1' },
  'sgi-b-2.0': { id: 'SGI-B-2.0', name: 'SGI Free Software License B v2.0' },
  'sgi-opengl': { id: 'SGI-OpenGL', name: 'SGI OpenGL License' },
  sgp4: { id: 'SGP4', name: 'SGP4 Permission Notice' },
  'shl-0.5': { id: 'SHL-0.5', name: 'Solderpad Hardware License v0.5' },
  'shl-0.51': {
    id: 'SHL-0.51',
    name: 'Solderpad Hardware License, Version 0.51',
  },
  'simpl-2.0': {
    id: 'SimPL-2.0',
    name: 'Simple Public License 2.0',
    isOsiApproved: true,
    keywords: ['osi-approved'],
  },
  sissl: {
    id: 'SISSL',
    name: 'Sun Industry Standards Source License v1.1',
    isOsiApproved: true,
    keywords: ['discouraged', 'retired', 'osi-approved'],
  },
  'sissl-1.2': {
    id: 'SISSL-1.2',
    name: 'Sun Industry Standards Source License v1.2',
  },
  sl: { id: 'SL', name: 'SL License' },
  sleepycat: {
    id: 'Sleepycat',
    name: 'Sleepycat License',
    isOsiApproved: true,
    keywords: ['discouraged', 'non-reusable', 'osi-approved'],
  },
  smlnj: { id: 'SMLNJ', name: 'Standard ML of New Jersey License' },
  smppl: { id: 'SMPPL', name: 'Secure Messaging Protocol Public License' },
  snia: { id: 'SNIA', name: 'SNIA Public License 1.1' },
  snprintf: { id: 'snprintf', name: 'snprintf License' },
  soundex: { id: 'Soundex', name: 'Soundex License' },
  'spencer-86': { id: 'Spencer-86', name: 'Spencer License 86' },
  'spencer-94': { id: 'Spencer-94', name: 'Spencer License 94' },
  'spencer-99': { id: 'Spencer-99', name: 'Spencer License 99' },
  'spl-1.0': {
    id: 'SPL-1.0',
    name: 'Sun Public License v1.0',
    isOsiApproved: true,
    keywords: ['discouraged', 'non-reusable', 'osi-approved'],
  },
  'ssh-keyscan': { id: 'ssh-keyscan', name: 'ssh-keyscan License' },
  'ssh-openssh': { id: 'SSH-OpenSSH', name: 'SSH OpenSSH license' },
  'ssh-short': { id: 'SSH-short', name: 'SSH short notice' },
  'sspl-1.0': { id: 'SSPL-1.0', name: 'Server Side Public License, v 1' },
  'standardml-nj': {
    id: 'StandardML-NJ',
    name: 'Standard ML of New Jersey License',
    isDeprecatedLicenseId: true,
  },
  'sugarcrm-1.1.3': {
    id: 'SugarCRM-1.1.3',
    name: 'SugarCRM Public License v1.1.3',
  },
  sunpro: { id: 'SunPro', name: 'SunPro License' },
  swl: {
    id: 'SWL',
    name: 'Scheme Widget Library (SWL) Software License Agreement',
  },
  swrule: { id: 'swrule', name: 'swrule License' },
  symlinks: { id: 'Symlinks', name: 'Symlinks License' },
  'tapr-ohl-1.0': {
    id: 'TAPR-OHL-1.0',
    name: 'TAPR Open Hardware License v1.0',
  },
  tcl: { id: 'TCL', name: 'TCL/TK License' },
  'tcp-wrappers': { id: 'TCP-wrappers', name: 'TCP Wrappers License' },
  termreadkey: { id: 'TermReadKey', name: 'TermReadKey License' },
  tmate: { id: 'TMate', name: 'TMate Open Source License' },
  'torque-1.1': {
    id: 'TORQUE-1.1',
    name: 'TORQUE v2.5+ Software License v1.1',
  },
  tosl: { id: 'TOSL', name: 'Trusster Open Source License' },
  tpdl: { id: 'TPDL', name: 'Time::ParseDate License' },
  'tpl-1.0': { id: 'TPL-1.0', name: 'THOR Public License 1.0' },
  ttwl: { id: 'TTWL', name: 'Text-Tabs+Wrap License' },
  ttyp0: { id: 'TTYP0', name: 'TTYP0 License' },
  'tu-berlin-1.0': {
    id: 'TU-Berlin-1.0',
    name: 'Technische Universitaet Berlin License 1.0',
  },
  'tu-berlin-2.0': {
    id: 'TU-Berlin-2.0',
    name: 'Technische Universitaet Berlin License 2.0',
  },
  ucar: { id: 'UCAR', name: 'UCAR License' },
  'ucl-1.0': {
    id: 'UCL-1.0',
    name: 'Upstream Compatibility License v1.0',
    isOsiApproved: true,
  },
  ulem: { id: 'ulem', name: 'ulem License' },
  'unicode-dfs-2015': {
    id: 'Unicode-DFS-2015',
    name: 'Unicode License Agreement - Data Files and Software (2015)',
  },
  'unicode-dfs-2016': {
    id: 'Unicode-DFS-2016',
    name: 'Unicode License Agreement - Data Files and Software (2016)',
    isOsiApproved: true,
  },
  'unicode-tou': { id: 'Unicode-TOU', name: 'Unicode Terms of Use' },
  unixcrypt: { id: 'UnixCrypt', name: 'UnixCrypt License' },
  unlicense: { id: 'Unlicense', name: 'The Unlicense', isOsiApproved: true },
  'upl-1.0': {
    id: 'UPL-1.0',
    name: 'Universal Permissive License v1.0',
    isOsiApproved: true,
  },
  'urt-rle': {
    id: 'URT-RLE',
    name: 'Utah Raster Toolkit Run Length Encoded License',
  },
  vim: { id: 'Vim', name: 'Vim License' },
  vostrom: { id: 'VOSTROM', name: 'VOSTROM Public License for Open Source' },
  'vsl-1.0': {
    id: 'VSL-1.0',
    name: 'Vovida Software License v1.0',
    isOsiApproved: true,
    keywords: ['discouraged', 'non-reusable', 'osi-approved'],
  },
  w3c: {
    id: 'W3C',
    name: 'W3C Software Notice and License (2002-12-31)',
    isOsiApproved: true,
    keywords: ['discouraged', 'non-reusable', 'osi-approved'],
  },
  'w3c-19980720': {
    id: 'W3C-19980720',
    name: 'W3C Software Notice and License (1998-07-20)',
  },
  'w3c-20150513': {
    id: 'W3C-20150513',
    name: 'W3C Software Notice and Document License (2015-05-13)',
  },
  w3m: { id: 'w3m', name: 'w3m License' },
  'watcom-1.0': {
    id: 'Watcom-1.0',
    name: 'Sybase Open Watcom Public License 1.0',
    isOsiApproved: true,
    keywords: ['discouraged', 'non-reusable', 'osi-approved'],
  },
  'widget-workshop': { id: 'Widget-Workshop', name: 'Widget Workshop License' },
  wsuipa: { id: 'Wsuipa', name: 'Wsuipa License' },
  wtfpl: { id: 'WTFPL', name: 'Do What The F*ck You Want To Public License' },
  wxwindows: {
    id: 'wxWindows',
    name: 'wxWindows Library License',
    isOsiApproved: true,
    isDeprecatedLicenseId: true,
    keywords: ['discouraged', 'non-reusable', 'osi-approved'],
  },
  x11: { id: 'X11', name: 'X11 License' },
  'x11-distribute-modifications-variant': {
    id: 'X11-distribute-modifications-variant',
    name: 'X11 License Distribution Modification Variant',
  },
  'xdebug-1.03': { id: 'Xdebug-1.03', name: 'Xdebug License v 1.03' },
  xerox: { id: 'Xerox', name: 'Xerox License' },
  xfig: { id: 'Xfig', name: 'Xfig License' },
  'xfree86-1.1': { id: 'XFree86-1.1', name: 'XFree86 License 1.1' },
  xinetd: { id: 'xinetd', name: 'xinetd License' },
  xlock: { id: 'xlock', name: 'xlock License' },
  xnet: {
    id: 'Xnet',
    name: 'X.Net License',
    isOsiApproved: true,
    keywords: ['osi-approved', 'discouraged', 'redundant'],
  },
  xpp: { id: 'xpp', name: 'XPP License' },
  xskat: { id: 'XSkat', name: 'XSkat License' },
  'ypl-1.0': { id: 'YPL-1.0', name: 'Yahoo! Public License v1.0' },
  'ypl-1.1': { id: 'YPL-1.1', name: 'Yahoo! Public License v1.1' },
  zed: { id: 'Zed', name: 'Zed License' },
  zeeff: { id: 'Zeeff', name: 'Zeeff License' },
  'zend-2.0': { id: 'Zend-2.0', name: 'Zend License v2.0' },
  'zimbra-1.3': { id: 'Zimbra-1.3', name: 'Zimbra Public License v1.3' },
  'zimbra-1.4': { id: 'Zimbra-1.4', name: 'Zimbra Public License v1.4' },
  zlib: {
    id: 'Zlib',
    name: 'zlib License',
    isOsiApproved: true,
    keywords: ['osi-approved'],
  },
  'zlib-acknowledgement': {
    id: 'zlib-acknowledgement',
    name: 'zlib/libpng License with Acknowledgement',
  },
  'zpl-1.1': { id: 'ZPL-1.1', name: 'Zope Public License 1.1' },
  'zpl-2.0': {
    id: 'ZPL-2.0',
    name: 'Zope Public License 2.0',
    isOsiApproved: true,
    keywords: ['discouraged', 'non-reusable', 'osi-approved'],
  },
  'zpl-2.1': {
    id: 'ZPL-2.1',
    name: 'Zope Public License 2.1',
    isOsiApproved: true,
  },
};
